<template>
  <div class='root'>
    <div class="head-warp">
      <div class="title">诚信合作，创新共享</div>
      <div class="description">赢科天地专注于中国教育行业信息化建设十余年，不断创新技术应用模式，成为引领高等院校信息化建设的高科技企业。</div>
      <div class="eng">Informatization<br>Normalization<br>Creativity<br>Optimization</div>
    </div>

    <div style="width: 1000px;margin:20px auto;background-color: #d0d0d0;height: 1px;"></div>

    <div class="advantage-wrap">
      <div class="advantage">
        <div class="title">
          <Menu style="width: 200px;" :open-names="openNames" ref="menus">
            <Submenu :name="index" v-for="(item, index) in menu" :key="item.id">
              <template slot="title" style="font-size: 20px;">
                {{item.title}}
              </template>
              <!-- 统一使用一个 v-for 循环 -->
              <MenuItem 
                class="menu-item" 
                :class="{ blod: index === 0 && getTf(item1.title) }" 
                v-for="item1 in item.children" 
                :key="item1.id"
                :name="item1.id"
                @click.native="scrollToCard(index)">
                <!-- 统一处理标题：如果是第一个菜单且以==结尾，则截断 -->
                {{ index === 0 && item1.title.endsWith('==') ? item1.title.slice(0, -2) : item1.title }}
              </MenuItem>
            </Submenu>
          </Menu>
        </div>
        <div style="flex: 1;margin-right: 20px;border-left: 1px solid #d0d0d0;margin-left: -50px;padding-left: 50px;margin-top: -30px;padding-top: 30px;">
          <div class="card-wrap" v-for="(prod, pIndex) in products" :key="prod.id" :ref="'card' + pIndex">
            <p class="title" style="font-size: 20px;font-weight: 700;padding-bottom: 10px;">{{prod.title}}</p>
            <Row :gutter="8" type="flex" justify="start" class="code-row-bg">
              <template v-for="(item,index) in prod.children">
                <Col span="24" :key="'h-'+index" v-if="item.group">
                  <p class="title" style="font-weight: 700;margin-bottom: 10px;">{{item.title}}</p>
                </Col>
                <Col span="8" :key="'c-'+index" v-else>
                  <Card class="bg" :style="getCardStyle(pIndex, index)">
                    <!-- <div class="title" style="height: 20px;line-height: 20px;" v-if="item.list[0]">{{item.list[0].title}}</div> -->
                    <p class="title1">{{item.title}}</p>
                    <p class="title2" v-if="item.list[0]">{{item.list[0].remark01}}</p>
                    <p class="content1" v-if="item.list[0]">{{item.list[0].remark16}}</p>
                    <span class="more" v-if="item.list[0].filePath" @click="goCard(pIndex, item, index)">了解更多</span>
                  </Card>
                </Col>
              </template>
            </Row>
          </div>
          <div style="width: 780px;height: 1px;background-color: #d0d0d0;margin-left: -50px;margin-top: 20px;margin-bottom: 20px;">
          </div>
          <div class="card-wrap">
            <p class="title" style="padding-bottom: 40px;">{{product3.title}}</p>
            <Row :gutter="4" type="flex" justify="start" class="code-row-bg">
              <Col span="8" v-for="(item, index) in product3.list" :key="index">
              <Card class="bg nobg" :class="index==0 ? 'bg1' : 'bg2'" dis-hover :padding="10">
                <div class="t1">{{item.title}}</div>
                <div class="t2">{{item.remark01}}</div>
                <div class="t3">{{item.remark16}}</div>
                <div class="t4">{{item.remark17}}</div>
              </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
    <div class="advantage-wrap">
      <div class="advantage">
        <div class="card-wrap">
          <Row :gutter="0" type="flex" justify="start" class="code-row-bg">
            <Col span="6">
            <Card class="bg nobg" style="background-color: #32717e;padding-left: 20px;" dis-hover :padding="2">
              <p class="text whitetext">我们如何提供帮助?</p>
            </Card>
            </Col>
            <Col span="6">
            <Card class="bg nobg bgc" dis-hover :padding="2">
              <div class="innerdiv" @click="goToNewPage1('/contactus','')" style="cursor: pointer;">
                <img src="../assets/t-1.png" class="cardimg">
                <span class="text whitetext">立即与我们交谈</span>
              </div>
            </Card>
            </Col>
            <Col span="6">
            <Card class="bg nobg bgc" dis-hover :padding="2">
              <div class="innerdiv">
                <img src="../assets/t-1.png" class="cardimg">
                <span class="text whitetext">致电赢科</span>
                <span style="font-size: 12px;position: absolute;bottom: 15px;left: 15px;color: #fff;padding: 0px 10px;">010-82887279;01082886006(座机);<br>向销售代表发送电子邮件</span>
              </div>
            </Card>
            </Col>
            <Col span="6">
            <Card class="bg nobg bgc" dis-hover :padding="2">
              <div class="innerdiv">
                <img src="../assets/t-1.png" class="cardimg">
                <span class="text whitetext">向技术顾问咨询</span>
				<span style="font-size: 12px;position: absolute;bottom: 32px;left: 15px;color: #fff;padding: 0px 10px;">zhangchao@incons.com.cn</span>
              </div>
            </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      product3: {
        title: '专业服务保障',
        list: [{
          title: '实施服务',
          remark01: '专业实施团队',
          remark16: '标准化实施流程',
          remark17: '快速交付，稳定上线',
        },
        {
          title: '运维服务',
          remark01: '7×24小时响应',
          remark16: '远程+现场双通道',
          remark17: 'SLA服务等级保障',
        },
        {
          title: '培训服务',
          remark01: '分层培训体系',
          remark16: '管理员/教师/学生',
          remark17: '配套教材与视频资料',
        }],
      },
      menu: [
          {
              "id": "1",
              "title": "软件系统类",
              "content": "",
              "desc": "",
              "children": [
                {
                    "id": "1-1",
                    "title": "在线教学软件==",
                    "content": "",
                    "desc": ""
                },
                {
                    "id": "1-1-1",
                    "title": "MOOC平台",
                    "content": "面向高校开放式网络教学，提供课程学习、在线测试与教学互动的全流程在线支撑，支持 PC 与移动端便捷访问。",
                    "desc": "在线开放课程、B/S架构、移动学习、教学互动、大数据分析",
                    "filePath": "@/assets/product/software/01/01.jpg"
                },
                {
                    "id": "1-1-2",
                    "title": "在线教学平台",
                    "content": "基于线上线下混合、课上课下翻转的教学理念，科学集成各类教学功能与资源，形成贯通教、学、管、评的一站式在线教学解决方案。",
                    "desc": "混合式教学、翻转课堂、资源整合、教学分析、多端应用",
                    "filePath": "@/assets/product/software/01/02.jpg"
                },
                {
                    "id": "1-1-3",
                    "title": "网络考试训练系统",
                    "content": "实现网络考试全过程管理，具备自动组卷、自动评分与智能统分能力，简化考试组织流程并提升考务管理水平。",
                    "desc": "在线考试、自动组卷、智能阅卷、题库管理、统计分析",
                    "filePath": "@/assets/product/software/01/03.jpg"
                },
                {
                    "id": "1-1-4",
                    "title": "掌上教学应用",
                    "content": "实现师生紧密互联，将信息化教学覆盖至课前、课上、课后各环节，为翻转课堂改革提供有力的移动端技术支撑。",
                    "desc": "移动教学、实时互动、班级管理、消息推送、资源分享",
                    "filePath": "@/assets/product/software/01/04.jpg"
                },
                {
                    "id": "1-2",
                    "title": "教学管理软件==",
                    "content": "",
                    "desc": ""
                },
                {
                    "id": "1-2-1",
                    "title": "一体化教学业务管理系统",
                    "content": "以统一门户与统一身份认证为基础，对课程、培养方案、排课、选课、考试、成绩、学籍、毕业等教学业务进行一体化管理。",
                    "desc": "教务管理、一体化平台、数据互通、多终端、智能决策",
                    "filePath": "@/assets/product/software/02/01.jpg"
                },
                {
                    "id": "1-2-2",
                    "title": "职业院校教学诊改一体化平台",
                    "content": "以目标链·标准链双向引擎为核心驱动，构建教学诊改工作体系，实现各类教学业务数据的自动诊断与持续改进。",
                    "desc": "教学诊改、质量监控、数据分析、预警推送、持续改进",
                    "filePath": "@/assets/product/software/02/02.jpg"
                },
                {
                    "id": "1-2-3",
                    "title": "课程申报评审系统",
                    "content": "提供快捷高效的网络申报评审管理，实现课程需求发布、申报、评审、确认的全流程信息化管理。",
                    "desc": "课程申报、专家评审、进度查询、多终端、自动生成大纲",
                    "filePath": "@/assets/product/software/02/03.jpg"
                },
                {
                    "id": "1-2-4",
                    "title": "排课系统",
                    "content": "基于先进算法与数据模型，提供手动与自动两种排课模式，有效解决班级、课程、教师、时间、地点等多维度排课冲突。",
                    "desc": "智能排课、冲突检测、自动排课、调停课、课表输出",
                    "filePath": "@/assets/product/software/02/04.jpg"
                },
                {
                    "id": "1-2-5",
                    "title": "教材管理系统",
                    "content": "集教材申请、审核、出版、统计、管理与交流于一体，全面提升高校教材管理工作的质量与效率。",
                    "desc": "教材申报、在线评审、出版管理、类型管理、查询统计",
                    "filePath": "@/assets/product/software/02/05.jpg"
                },
                {
                    "id": "1-2-6",
                    "title": "教学媒体资源管理系统",
                    "content": "通过统一的应用框架与数据底层，实现对各类教学资源的集约管理、高效利用与共建共享。",
                    "desc": "资源管理、共建共享、标准化接口、多终端、非结构化数据",
                    "filePath": "@/assets/product/software/02/06.jpg"
                },
                {
                    "id": "1-2-7",
                    "title": "毕业设计及论文管理系统",
                    "content": "涵盖选题、申报、答辩、评阅等全过程管理，实现各环节信息化管控，提升学生学术思维与实践能力。",
                    "desc": "毕业设计、论文管理、全过程管控、盲审支持、师生互动",
                    "filePath": "@/assets/product/software/02/07.jpg"
                },
                {
                    "id": "1-2-8",
                    "title": "大学生创新创业计划管理系统",
                    "content": "以项目管理为核心，对创新创业训练项目的立项、申报、审批、中期检查、结题等环节提供动态过程管理。",
                    "desc": "双创管理、项目全过程、经费管理、成果展示、动态管理",
                    "filePath": "@/assets/product/software/02/08.jpg"
                },
                {
                    "id": "1-2-9",
                    "title": "大学生学科竞赛项目管理系统",
                    "content": "对学科竞赛项目的申报、审核、报名、获奖、经费等进行全流程动态管理，提升竞赛组织管理效率",
                    "desc": "学科竞赛、报名管理、评审管理、经费管理、成果展示",
                    "filePath": "@/assets/product/software/02/09.jpg"
                },
                {
                    "id": "1-2-10",
                    "title": "实验实践教学管理系统",
                    "content": "可与教务管理系统无缝对接，实现对实验教学计划、人员、场地、设备等要素的信息化管理。",
                    "desc": "实验教学、实践管理、资源共享、统计分析、无缝对接",
                    "filePath": "@/assets/product/software/02/10.jpg"
                },
                {
                    "id": "1-2-11",
                    "title": "国内国际合作交流项目管理系统",
                    "content": "按照流转审批流程全程跟踪项目信息与签批进展，实现国际交流合作项目的标准化、信息化、一体化管理。",
                    "desc": "合作交流、项目管理、自定义工作流、多部门审核、在线交流",
                    "filePath": "@/assets/product/software/02/11.jpg"
                },
                {
                    "id": "1-2-12",
                    "title": "教学项目管理系统",
                    "content": "面向教学改革、教学成果、公选课等教学项目的在线申报与管理，支持院系审核、专家评审、学校确认等流程。",
                    "desc": "教学项目、在线申报、专家评审、进度预警、数据统计",
                    "filePath": "@/assets/product/software/02/12.jpg"
                },
                {
                    "id": "1-2-13",
                    "title": "教学经费管理系统",
                    "content": "实现教学经费报销、借款、下拨等财务手续的网络办理，支持经费使用情况的实时掌握与统计查询",
                    "desc": "经费管理、在线报销、审核流程、预算管理、OA集成",
                    "filePath": "@/assets/product/software/02/13.jpg"
                },
                {
                    "id": "1-2-14",
                    "title": "专业选择系统",
                    "content": "为教务部门与学生提供网络化的专业意向填报工具，实现专业选择信息的对称共享与志愿填报录取的高效处理。",
                    "desc": "专业选择、志愿填报、录取规则、大类培养、多终端",
                    "filePath": "@/assets/product/software/02/14.jpg"
                },
                {
                    "id": "1-2-15",
                    "title": "国际专业认证平台",
                    "content": "聚焦数据收集、达成度计算、自评报告撰写与文档资料管理，助力高校高效组织开展国际专业认证工作。",
                    "desc": "专业认证、达成度计算、自评报告、材料管理、华盛顿协议",
                    "filePath": "@/assets/product/software/02/15.jpg"
                },
                {
                    "id": "1-2-16",
                    "title": "顶岗实习系统",
                    "content": "实现学生、教师、学校、实习单位多方立体式实时管理，保障实习正规安全，全面提升顶岗实习管理水平。",
                    "desc": "顶岗实习、智能签到、移动办公、数据统计、产教融合",
                    "filePath": "@/assets/product/software/02/16.jpg"
                },
                {
                    "id": "1-3",
                    "title": "教学评价软件==",
                    "content": "",
                    "desc": ""
                },
                {
                    "id": "1-3-1",
                    "title": "教学质量状态数据库",
                    "content": "实现高校教学基本状态数据的自动采集与智能统计分析，以数字化方式直观呈现教学运行状态，为持续改进提供支撑",
                    "desc": "数据采集、智能统计、状态监测、表单定制、决策支持",
                    "filePath": "@/assets/product/software/03/01.jpg"
                },
                {
                    "id": "1-3-2",
                    "title": "课程质量评价系统",
                    "content": "采用科学评价标准与计算模型，通过智能化数据采集与统计分析自动生成课程评价结论，提升评价的客观性与科学性",
                    "desc": "课程评价、指标体系、数据采集、统计分析、等级排名",
                    "filePath": "@/assets/product/software/03/02.jpg"
                },
                {
                    "id": "1-3-3",
                    "title": "学生选拔培养管理系统",
                    "content": "实现对学生考试报名、资格审查、考试安排、成绩公布等选拔环节的信息化管理，并对培养计划学生全过程跟踪。",
                    "desc": "拔尖人才、选拔管理、成长跟踪、项目管理、统计报表",
                    "filePath": "@/assets/product/software/03/03.jpg"
                },
                {
                    "id": "1-3-4",
                    "title": "第二学分认定系统",
                    "content": "对学生素质拓展与第二学分进行规范化、数字化管理，配合第二成绩单直观反映学生在校综合表现",
                    "desc": "素质拓展、学分认定、数据采集、第二成绩单、多终端",
                    "filePath": "@/assets/product/software/03/04.jpg"
                },
                {
                    "id": "1-3-5",
                    "title": "综合评教管理系统",
                    "content": "融合学生评教、同行评教与专家评教，通过大数据分析生成精准的教师教学量化评价数据。",
                    "desc": "教师评价、多维度评教、问卷调查、统计分析、大数据",
                    "filePath": "@/assets/product/software/03/05.jpg"
                },
                {
                    "id": "1-3-6",
                    "title": "教学工作量统计管理系统",
                    "content": "按照教师申报—院系初审—学校终审流程，自动从相关业务系统抽取教师工作量数据进行计量管理。",
                    "desc": "工作量统计、自动采集、审核流程、计量管理、网络化管理",
                    "filePath": "@/assets/product/software/03/06.jpg"
                },
                {
                    "id": "1-3-7",
                    "title": "教师发展管理系统",
                    "content": "实现教发资讯、教师培训、教学竞赛、问卷调查、研究项目等教师发展工作的数字化、网络化、智能化管理。",
                    "desc": "教师发展、培训管理、教学竞赛、资源管理、多维度统计",
                    "filePath": "@/assets/product/software/03/07.jpg"
                },
                {
                    "id": "1-3-8",
                    "title": "助教管理系统",
                    "content": "覆盖助教申请、选拔、录取、培训、考核、评优与津贴发放等业务，贯通助教管理各环节。",
                    "desc": "助教管理、招聘培训、津贴发放、考核评优、审批流程",
                    "filePath": "@/assets/product/software/03/08.jpg"
                },
                {
                    "id": "1-3-9",
                    "title": "大学英语实验教学与评估系统",
                    "content": "支持学生以个人或团队方式完成英语实验任务，在场景式环境中训练听说能力，实现应试向实践应用的转变。",
                    "desc": "英语教学、实验教学、听说训练、教学评价、案例教学",
                    "filePath": "@/assets/product/software/03/09.jpg"
                },
                {
                    "id": "1-4",
                    "title": "其他业务软件==",
                    "content": "",
                    "desc": ""
                },
                {
                    "id": "1-4-1",
                    "title": "学工信息管理系统",
                    "content": "紧贴高校学工管理实际，涵盖奖惩、奖助学金、勤工助学、党建、社团等业务环节，提升学工管理质量效率。",
                    "desc": "学生工作、奖惩管理、奖助学金、党建管理、协同高效",
                    "filePath": "@/assets/product/software/04/01.jpg"
                },
                {
                    "id": "1-4-2",
                    "title": "教务OA系统",
                    "content": "采用先进工作流架构，实现公文、公务、信息推送与协作沟通等教务日常办公自动化。",
                    "desc": "办公自动化、工作流、公文管理、协同办公、系统集成",
                    "filePath": "@/assets/product/software/04/02.jpg"
                }
              ]
          },
          {
              "id": "2",
              "title": "内容资源类",
              "content": "",
              "desc": "",
              "children": [
                  {
                      "id": "2-1",
                      "title": "在线课程/智慧课程",
                      "content": "基于在线学习平台，提供传统 MOOC 课程与 AI 知识图谱助力的智慧课程一体化建设，覆盖课程设计、视频制作、题库建设、知识图谱构建与 AI 教学助手接入等全链条资源开发",
                      "desc": "课程建设、MOOC、知识图谱、AI赋能、教学资源",
                      "filePath": "@/assets/product/resource/01.pdf"
                  },
                  {
                      "id": "2-2",
                      "title": "虚拟仿真实验平台",
                      "content": "集虚拟实验项目建设、展示、管理、共享、交流、服务于一体的网络教学管理平台，可与 MOOC 平台无缝集成，支持师生开展虚拟实验教学与互动",
                      "desc": "虚拟仿真、实验教学、MOOC集成、在线互动、资源共享",
                      "filePath": "@/assets/product/resource/02.jpg"
                  }
              ]
          },
          {
              "id": "3",
              "title": "设备环境类",
              "content": "",
              "desc": "",
              "children": [
                  {
                      "id": "3-1",
                      "title": "智慧教室",
                      "content": "充分应用物联网、云计算与无线通信技术，搭建具备信息感知、呈现、传输与交互能力的现代化课堂，实现教学环境的智能化管理与可视化管控。",
                      "desc": "智慧教室、物联网、互动教学、行为分析、线上线下融合",
                      "filePath": "@/assets/product/equipment/01.jpg"
                  },
                  {
                      "id": "3-2",
                      "title": "学生成绩查询打印一体机",
                      "content": "将网络数据库与自助终端有机结合，为学生提供培养方案、选课、考试、成绩等信息查询及成绩单、在读证明等文件自助打印服务。",
                      "desc": "自助终端、成绩查询、打印服务、人脸识别、移动支付",
                      "filePath": "@/assets/product/equipment/02.jpg"
                  },
                  {
                      "id": "3-3",
                      "title": "未来学习中心",
                      "content": "以 AI 为底座，整合智慧学习空间、平台与资源三大核心，构建虚实共生、时空无限、数智赋能的智慧系统，驱动教、学、研、评、管、服全流程重构。",
                      "desc": "未来学习中心、AI原生、智慧空间、知识图谱、沉浸式学习",
                      "filePath": "@/assets/product/equipment/03.pdf"
                  }
              ]
          },
          {
              "id": "4",
              "title": "咨询服务类",
              "content": "",
              "desc": "",
              "children": [
                  {
                      "id": "4-1",
                      "title": "教师培训",
                      "content": "围绕智慧教学、教育信息化应用、AI 教学工具、课程设计与教学创新等主题，为高校教师提供线上线下结合的定制化培训方案，助力教师队伍数字化能力提升。",
                      "desc": "教师培训、信息化素养、教学创新、AI教学、定制方案",
                      "filePath": ""
                  },
                  {
                      "id": "4-2",
                      "title": "咨询服务",
                      "content": "面向高校教育数字化转型，提供智慧校园规划、教学改革顶层设计、教学质量保障体系建设、数据治理与决策支持等专业咨询，助力构建可持续的教育信息化发展路径。",
                      "desc": "教育咨询、数字化转型、顶层设计、质量保障、数据治理",
                      "filePath": ""
                  }
              ]
          }
      ],
      openNames: [0, 1, 2, 3],
    }
  },
  computed: {
    products() {
      return this.menu.map((cat) => {
        let children = []
        let group = null
        for (const child of cat.children || []) {
          const isHeader =
            /^[^-]+-[^-]+$/.test(child.id || '') && (child.title || '').endsWith('==')
          if (isHeader) {
            group = {
              title: child.title.slice(0, -2),
              id: child.id,
              group: true,
            }
            children.push(group)
          } else {
            const card = {
              title: child.title,
              id: child.id,
              group: false,
              list: [{
                title: child.title,
                remark01: child.desc || '',
                remark16: child.content || '',
                filePath: child.filePath || '',
              }],
            }
            if (group) {
              group.list = group.list || []
              group.list.push(card)
            }
            children.push(card)
          }
        }
        return { title: cat.title, id: cat.id, children }
      })
    },
  },
  methods: {
    getStyles(index) {
      return {
        backgroundImage: 'url(' + require(`../assets/bg_${index}.jpg`) + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }
    },
    getCardStyle(pIndex, index) {
      let total = 0
      for (let i = 0; i < pIndex; i++) {
        total += this.products[i].children.length
      }
      total += index
      return this.getStyles((total % 6) + 1)
    },
    goCard(pIndex, item, index) {
      // if (pIndex === 0) {
      //   this.goToNewPage('/specialproducts', item, index, item.title)
      // } else {
        this.goToNewPage1('/productionfive', item)
      // }
    },
    goToNewPage(path1, data, index, title) {
	    let routeUrl = this.$router.resolve({
	       path: path1,
	       query: {index: index,
          title: title,
          id: data.id}
	    });
	    window.open(routeUrl.href, '_blank');
    },
    goToNewPage1(path, data) {
      // window.localStorage.setItem('productJson2', JSON.stringify(data))
      console.log(data)
      // if(path=='/productionfive'){
        let routeUrl = this.$router.resolve({
            path: path,
            query: {
              id: data.id,
              filePath: data.list[0].filePath,
            },
          });
        window.open(routeUrl.href, '_blank');
      // }else{
      //   this.$router.push({
      //     path: path,
      //     query: {
      //       id: data.id,
      //       filePath: data.list[0].filePath,
      //     }
      //   })
      // }
    },
    getTf(item) {
      return item.endsWith('==')
    },
    scrollToCard(index) {
      // const refName = 'card' + index
      // const el = this.$refs[refName] ? this.$refs[refName][0] : null
      // if (!el) return
      // const top = el.getBoundingClientRect().top + window.pageYOffset - 80
      // window.scrollTo({ top, behavior: 'smooth' })
    },
    goImage(item) {
      // if (item.img) {
      //   window.open(item.img)
      // }else{
      //   if(item.list&&item.list[0].img){
      //     window.open(item.list[0].img)
      //   }
	    // }
    },
  },
  mounted() {
    let url =
      this.HOST +
      'inconWeb/getProductsIndexByParentId?parentid=C839903BBE8909FAE05509994F3826F5&moduleOrder=ordernum&contentOrder=ordernum&websiteid=4'
    url = this.$getJsonUrl(url)
    this.$axios.get(url).then((res) => {
      let list = res.data.content.list
      this.product1 = list[0]
      this.product2 = list[1]
      this.product3 = list[2]
    })

    let url1 =
      this.HOST +
      'inconWeb/getMenuListByParentId?parentid=C839903BBE8909FAE05509994F3826F5&moduleOrder=ordernum&contentOrder=ordernum&websiteid=4'
    url1 = this.$getJsonUrl(url1)
    this.$axios.get(url1).then((res) => {
      let list = res.data.content.list
      this.menu = list[1].children
      this.menu1 = list[0].children
      for (let j = 0; j < this.menu[0].children.length; j++) {
        let obj = {
          title: this.menu[0].children[j].title + '==',
          img: '',
        }
        this.textArray1.push(obj)
        for (let k = 0; k < this.menu[0].children[j].list.length; k++) {
          let obj = {
            title: this.menu[0].children[j].list[k].title,
            img: this.menu[0].children[j].list[k].img,
          }
          this.textArray1.push(obj)
        }
      }
      this.$nextTick(() => {
        this.$refs['menus'].updateOpened()
      })
    })
  },
}
</script>

<style scoped lang="less">
.menu-item {
  width: 200px;
  height: 1.5rem;
  padding-left: 15px;
  overflow: hidden;
  font-weight: 500;
  font-size: 13px;
}
.root {
  .head-warp {
    min-width: 1200px;
    padding: 20px 80px;
    text-align: left;
    background-image: url('../assets/zpqs.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    .title {
      font-size: 18px;
      font-weight: 600;
    }

    .description {
      width: 320px;
      font-size: 16px;
    }

    .eng {
      position: absolute;
      top: 19px;
      right: 80px;
      font-weight: 800;
      font-size: 25px;
      line-height: 1.7rem;
    }
  }

  .advantage {
    display: flex;
    width: 1000px;
    margin: 20px auto;
    padding: 10px 0;

    .title {
      width: 250px;

      .title1 {
        font-size: 14px;
      }
    }

    .title:hover {
      cursor: pointer;
    }

    .card-wrap {
      flex: 1;
      position: relative;
      // background-color: #32717e;
      // padding-right: 20px;

      .bg {
        margin-bottom: 10px;
        // background-image: url('../assets/zpqs-3.jpg');
        // background-repeat: no-repeat;
        // background-size: cover;
        color: #fff;
        min-height: 250px;

        .text {
          // height: 70px;
          font-size: 14px;
          height: 100px;
          overflow: hidden;
        }

        .text1 {
          // height: 70px;
          font-size: 14px;
          height: 150px;
          overflow: hidden;
        }
      }

      .title {
        width: 100%;
        padding-right: 0;
        font-size: 15px;
        text-align: left;
        overflow: hidden;
        word-break: break-all;
        cursor: auto;
      }

      .title1 {
        font-weight: 550;
        font-size: 18px;
      }

      .title2 {
        font-size: 14px;
        font-weight: 600;
        margin-top: 10px;
      }

      .content1 {
        margin-top: 10px;
        font-size: 12px;
      }

      .more {
        background-color: #ffffff;
        color: black;
        font-size: 12px;
        border-radius: 20px;
        padding: 2px 10px;
        position: absolute;
        bottom: 30px;
        cursor: pointer;
      }

      .nobg {
        color: #000;
        border: none;
      }

      .whitetext {
        margin-top: 50px;
        color: white;
      }

      .innerdiv {
        background-color: #79a1a9;
        height: 120px;
        padding: 10px;
        margin-top: 20px;
        position: relative;
      }

      .cardimg {
        width: 30px;
        height: 30px;
        vertical-align: middle;
      }

      .bgc {
        background-color: #32717e;
      }

      .bg1 {
        background-color: #d6e4de;
        height: 400px;
        overflow: hidden;
      }

      .bg2 {
        background-color: #eaf1f2;
        height: 400px;
        overflow: hidden;
      }

      .t1 {
        font-size: 20px;
        color: #606060;
      }

      .t2 {
        font-size: 30px;
        font-weight: 600;
        color: #606060;
        height: 100px;
      }

      .t3 {
        font-size: 14px;
        font-weight: 550;
        color: #606060;
      }

      .t4 {
        font-size: 14px;
        color: #606060;
      }
    }
  }
}

.blod {
  font-weight: 600 !important;
}
</style>
